<template>
    <div class="container">
        <div class="nav_header">
            <h2>
                店铺详情
            </h2>
            <div class="subtitle">订单号：{{ order_no }}</div>
        </div>

        <el-steps :active="data_source.step_digit" finish-status="success" simple style="margin-top: 20px">
            <el-step title="定金"></el-step>
            <el-step title="验店"></el-step>
            <el-step title="合同"></el-step>
            <el-step title="尾款"></el-step>
            <el-step title="完成"></el-step>
        </el-steps>

        <white-space />

        <!-- 定金 -->
        <template v-if="data_source.status == 0 && data_source.step == 'created'">
            <el-button type="primary" @click="on_pay_deposit_pre(data_source)">支付定金：￥{{ data_source.amount_deposit }}</el-button>
            <white-space />
        </template>

        <!-- 验店 -->
        <template v-if="data_source.status == 0 && data_source.step == 'deposit'">
            <el-button type="primary" @click="on_verify_pre(data_source)">完成店铺验证</el-button>
            <white-space />
        </template>

        <!-- 尾款 -->
        <template v-if="data_source.status == 0 && data_source.step == 'contract'">
            <el-button type="primary" @click="on_balance_pre(data_source)"
                >支付尾款：￥{{ data_source.amount - data_source.amount_deposit }}</el-button
            >
            <white-space />
        </template>
        <template v-if="data_source.status == 0 && data_source.step == 'verify'">
            <el-alert title="温馨提示" type="info" description="请等待销售人员联系并协助您签署相关合同。" show-icon> </el-alert>
            <white-space />
        </template>

        <el-card shadow="hover" style="position: relative">
            <div class="postmark" v-if="data_source.completed_at">
                <i v-if="data_source.status == -1" class="iconfont icon-yiquxiao cancel"></i>
                <i v-if="data_source.status == 1" class="iconfont icon-yiwancheng success"></i>
            </div>

            <div slot="header" class="header">
                订单信息
            </div>

            <table class="el-table">
                <tr>
                    <td>订单号</td>
                    <td>{{ data_source.order_no }}</td>
                </tr>
                <tr>
                    <td>店铺信息</td>
                    <td>编号：{{ data_source.resource_id }} • {{ data_source.name }}</td>
                </tr>

                <tr>
                    <td>订单金额</td>
                    <td>￥{{ data_source.amount }}</td>
                </tr>
                <tr>
                    <td>订单定金</td>
                    <td>￥{{ data_source.amount_deposit }}</td>
                </tr>
                <tr>
                    <td>已付金额</td>
                    <td>￥{{ data_source.amount_paid }}</td>
                </tr>
                <tr>
                    <td>剩余尾款</td>
                    <td>￥{{ data_source.amount - data_source.amount_paid }}</td>
                </tr>
                <tr>
                    <td>订单创建时间</td>
                    <td>{{ data_source.created_at | dateformat("YYYY-MM-DD HH:mm") }}</td>
                </tr>
            </table>
        </el-card>

        <white-space />

        <el-card shadow="hover" title="媒体列表" :body-style="{ padding: 0 }">
            <div slot="header" class="header">
                合同列表
            </div>

            <el-table v-loading="loading_contract" :data="data_contract">
                <el-table-column label="签署状态" width="90" prop="status_text" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status == 'success'" type="success">{{ scope.row.status_text }}</el-tag>
                        <el-tag v-if="scope.row.status == 'fail'" type="danger">{{ scope.row.status_text }}</el-tag>
                        <el-tag v-if="scope.row.status == 'wait'" type="info">{{ scope.row.status_text }}</el-tag>
                        <!-- <el-tag v-if="scope.row.status == 2" type="warning">{{ scope.row.status_text }}</el-tag> -->
                    </template>
                </el-table-column>

                <el-table-column prop="contract_id" label="合同编号" width="200"> </el-table-column>

                <el-table-column prop="name" label="合同名称">
                    <div slot-scope="scope">
                        {{ scope.row.title }}
                    </div>
                </el-table-column>

                <el-table-column prop="created_at" label="创建时间" width="150">
                    <template slot-scope="scope">
                        {{ scope.row.created_at | dateformat("YYYY-MM-DD HH:mm") }}
                    </template>
                </el-table-column>

                <el-table-column width="100" label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button @click="on_preview(scope.row)" type="text" size="small">查看</el-button>
                        <el-button @click="on_down(scope.row)" type="text" size="small">下载</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- <white-space />
            <el-alert
                title="无论推广是否成功，媒体的处理状态都会显示完成，未完成或者拒稿的媒体，系统将会自动退款到您的个人账户里。"
                :closable="false"
                type="info"
                show-icon
            >
            </el-alert> -->
        </el-card>

        <white-space />
        <el-button
            icon="el-icon-delete"
            type="danger"
            plain
            @click="on_delete"
            v-if="data_source.status == 0 && data_source.step == 'created'"
            >删除订单</el-button
        >
    </div>
</template>

<script>
    import moment from "moment";
    import common from "./common.js";
    export default {
        mixins: [common],
        created() {
            this.load();
        },
        data() {
            return {
                amount: "",
                data: "",
                loading_contract: false,
                data_contract: [],
                data_source: {},
                password_pay: null,
            };
        },
        computed: {
            order_no() {
                return this.$route.params.id;
            },
        },
        methods: {
            load() {
                this.$http.get("order/" + this.order_no).then((response) => {
                    if (response.success) {
                        this.data_source = response.data;
                        this.load_contract();
                    }
                });
            },
            load_contract() {
                this.loading_contract = true;
                this.$http
                    .get("order/" + this.order_no + "/contract")
                    .then((response) => {
                        if (response.success) {
                            this.data_contract = response.data;
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loading_contract = false;
                    });
            },
            on_delete() {
                this.$confirm("是否要删除当前订单？", "提醒", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    beforeClose: (action, instance, done) => {
                        if (action === "confirm") {
                            instance.confirmButtonLoading = true;
                            instance.confirmButtonText = "处理中...";

                            this.$http;
                            this.$http
                                .delete("/order/" + this.order_no)
                                .then((response) => {
                                    if (!response.success) {
                                        instance.callback = () => this.$alert(response.message, "失败");
                                    } else {
                                        this.$router.replace("/order");
                                    }
                                })
                                .catch(() => {
                                    instance.confirmButtonLoading = false;
                                    done();
                                })
                                .then(() => {
                                    instance.confirmButtonLoading = false;
                                    done();
                                });
                        } else {
                            done();
                        }
                    },
                });
            },
            on_preview(record) {
                window.open(record.viewpdf_url);
            },
            on_down(record) {
                window.open(record.download_url);
            },
        },
    };
</script>

<style scoped lang="less">
    .container {
        .descriptions {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 700px;
            vertical-align: middle;
            display: inline-block;
        }

        .header {
            font-size: 16px;
        }

        .title {
            height: 70px;
            vertical-align: top;
            font-size: 16px;
            color: #333333;
            height: 40px;
        }

        .title > span {
            display: inline-block;
            width: 5px;
            height: 18px;
            background-color: #f08c19;
        }

        .table > li:nth-child(3) > span {
            /*width: 200px;*/
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            vertical-align: middle;
        }

        .pay-success {
            color: #f08c19;
        }
        .postmark {
            width: 100px;
            height: 100px;
            display: inline-block;
            position: absolute;
            z-index: 1;
            right: 0;
            margin-right: 30px;
            margin-top: -50px;
            top: 100px;
            opacity: 0.7;
            .iconfont {
                font-size: 84px;
                position: absolute;
                &.success {
                    color: #ff5722;
                }
                &.cancel {
                    color: #9e9e9e;
                }
            }
        }
    }
</style>
